import { render, staticRenderFns } from "./FormAccessRequest.vue?vue&type=template&id=069262a7&lang=pug"
import script from "./FormAccessRequest.vue?vue&type=script&lang=js"
export * from "./FormAccessRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('069262a7')) {
      api.createRecord('069262a7', component.options)
    } else {
      api.reload('069262a7', component.options)
    }
    module.hot.accept("./FormAccessRequest.vue?vue&type=template&id=069262a7&lang=pug", function () {
      api.rerender('069262a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormAccessRequest.vue"
export default component.exports